import { render, staticRenderFns } from "./materialAdd.vue?vue&type=template&id=e3fd004a&scoped=true"
import script from "./materialAdd.vue?vue&type=script&lang=js"
export * from "./materialAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fd004a",
  null
  
)

export default component.exports